// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-parent-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 800px;
    padding-left: 20px;
}

.feedback-info-box {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 20px;
    background-color: #5616ea25;
    border-radius: 10px;
    padding: 15px;
    padding-top: 12px;
    padding-bottom: 12px;
    line-height: 1.45;
    border-left: 5px solid #5616ea;
}

.feedback-info-icon {
    font-size: 32px;
    color: #5616ea;
}

.feedback-info-text {
    display: flex;
    flex-direction: column;
}

.feedback-info-text p {
    margin: 0;
}

.feedback-title {
    margin: 0 0 6px 0;
    font-size: 18px;
}

.feedback-form-card {
    display: flex;
    flex-direction: column;
    gap: 14px;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 14px;
    border: 1px solid #eee;
}

.feedback-loading-spinner {
    width: 16px;
    height: 16px;
    border: 3px solid #ffffff;
    border-top: 3px solid #e5e5e5;
    border-radius: 50%;
    animation: feedback-spin 1s linear infinite;
    display: inline-block;
    vertical-align: middle;
}

@keyframes feedback-spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.feedback-status {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    padding: 10px;
    border-radius: 10px;
}

.feedback-status-icon.success {
    color: #26a269;
}

.feedback-status-icon.error {
    color: #d93025;
}

.feedback-status.success {
    background: #eaf7f1;
    color: #124c2e;
    border: 1px solid #cdeede;
}

.feedback-status.error {
    background: #fdecea;
    color: #6a1a13;
    border: 1px solid #f7c6c1;
}

@media (max-width: 640px) {
    .feedback-parent-container {
        padding: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/feedback.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,2CAA2C;IAC3C,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".feedback-parent-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    max-width: 800px;\r\n    padding-left: 20px;\r\n}\r\n\r\n.feedback-info-box {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    gap: 20px;\r\n    background-color: #5616ea25;\r\n    border-radius: 10px;\r\n    padding: 15px;\r\n    padding-top: 12px;\r\n    padding-bottom: 12px;\r\n    line-height: 1.45;\r\n    border-left: 5px solid #5616ea;\r\n}\r\n\r\n.feedback-info-icon {\r\n    font-size: 32px;\r\n    color: #5616ea;\r\n}\r\n\r\n.feedback-info-text {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.feedback-info-text p {\r\n    margin: 0;\r\n}\r\n\r\n.feedback-title {\r\n    margin: 0 0 6px 0;\r\n    font-size: 18px;\r\n}\r\n\r\n.feedback-form-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 14px;\r\n    background-color: #ffffff;\r\n    border-radius: 10px;\r\n    padding: 14px;\r\n    border: 1px solid #eee;\r\n}\r\n\r\n.feedback-loading-spinner {\r\n    width: 16px;\r\n    height: 16px;\r\n    border: 3px solid #ffffff;\r\n    border-top: 3px solid #e5e5e5;\r\n    border-radius: 50%;\r\n    animation: feedback-spin 1s linear infinite;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n\r\n@keyframes feedback-spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n}\r\n\r\n.feedback-status {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-size: 14px;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n}\r\n\r\n.feedback-status-icon.success {\r\n    color: #26a269;\r\n}\r\n\r\n.feedback-status-icon.error {\r\n    color: #d93025;\r\n}\r\n\r\n.feedback-status.success {\r\n    background: #eaf7f1;\r\n    color: #124c2e;\r\n    border: 1px solid #cdeede;\r\n}\r\n\r\n.feedback-status.error {\r\n    background: #fdecea;\r\n    color: #6a1a13;\r\n    border: 1px solid #f7c6c1;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n    .feedback-parent-container {\r\n        padding: 20px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
